/** Default theme settings */
export const themeSettings: App.Theme.ThemeSetting = {
  themeScheme: 'light',
  grayscale: false,
  recommendColor: false,
  themeColor: '#5E63E4', // 主题色
  otherColor: {
    info: '#5E63E4',
    success: '#00B42A',
    warning: '#FF7D00',
    error: '#F53F3F',
    backPrimary: '#F2F3FF',
    backGrey: '#F2F3F5',
    deepBlack: '#1D2129',
    borderGrey: '#E5E6EB',
    deepGrey: '#4E5969',
    lightGrey: '#86909C'
  },
  isInfoFollowPrimary: true,
  layout: {
    mode: 'vertical',
    scrollMode: 'content'
  },
  page: {
    animate: true,
    animateMode: 'fade-slide'
  },
  header: {
    height: 116, // 标题高度
    breadcrumb: {
      visible: true,
      showIcon: true
    },
    close: {
      /** 是否显示关闭图标 */
      visible: false
    }
  },
  tab: {
    visible: true,
    cache: true,
    height: 44,
    mode: 'chrome'
  },
  fixedHeaderAndTab: true,
  sider: {
    inverted: false,
    width: 220,
    collapsedWidth: 48,
    mixWidth: 90,
    mixCollapsedWidth: 64,
    mixChildMenuWidth: 200
  },
  footer: {
    visible: false,
    fixed: false,
    height: 50,
    right: true,
    content: {
      back: false, // 是否显示
      backLabel: 'common.back', // 显示文案
      backDisabled: false, // 是否禁用
      confirm: false,
      confirmLabel: 'common.ensure',
      confirmDisabled: false,
    }
  },
  siderTitle: {
    height: 136
  }
};

/**
 * Override theme settings
 *
 * If publish new version, use `overrideThemeSettings` to override certain theme settings
 */
export const overrideThemeSettings: Partial<App.Theme.ThemeSetting> = {
};
